import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link, useNavigate } from "react-router-dom";
import { ChartBar } from "@phosphor-icons/react";

export default function AnalyticsPage() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.listCampaigns().then(setItems); }, []);
  const sentItems = items.filter(c => c.status === "sent" || c.status === "sending");

  const toggle = (id) => setSelected(s => s.includes(id) ? s.filter(x => x !== id) : (s.length >= 6 ? s : [...s, id]));

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <h2 className="font-heading text-2xl font-medium tracking-tight">Analytics</h2>
          <p className="text-sm text-zinc-500 mt-0.5">Engagement across all campaigns. Tick 2–6 campaigns to compare them side by side.</p>
        </div>
        {selected.length >= 2 && (
          <button data-testid="compare-btn" onClick={() => nav(`/analytics/compare?ids=${selected.join(",")}`)} className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-md bg-zinc-950 text-white hover:bg-zinc-800">
            <ChartBar size={14}/> Compare {selected.length} campaigns
          </button>
        )}
      </div>
      <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-xs text-zinc-500 border-b border-zinc-200"><tr>
            <th className="px-3 py-2 w-8"/>
            <th className="text-left px-3 py-2 font-medium">Campaign</th>
            <th className="text-right px-3 py-2 font-medium">Recipients</th>
            <th className="text-right px-3 py-2 font-medium">Sent</th>
            <th className="text-right px-3 py-2 font-medium">Opens</th>
            <th className="text-right px-3 py-2 font-medium">Clicks</th>
            <th className="text-right px-3 py-2 font-medium">Open %</th>
            <th className="text-right px-3 py-2 font-medium">Click %</th>
            <th className="text-right px-3 py-2 font-medium">Bounced</th>
            <th className="text-right px-3 py-2 font-medium">Unsub</th>
          </tr></thead>
          <tbody>
            {sentItems.map(c => {
              const s = c.stats || {};
              const sent = s.sent || 0;
              return (
                <tr key={c.id} className="border-b border-zinc-100 hover:bg-zinc-50/60">
                  <td className="px-3 py-2.5">
                    <input data-testid={`compare-check-${c.id}`} type="checkbox" checked={selected.includes(c.id)} onChange={() => toggle(c.id)}/>
                  </td>
                  <td className="px-3 py-2.5">
                    <Link to={`/campaigns/${c.id}`} className="font-medium hover:underline">{c.name}</Link>
                    <div className="text-[11px] text-zinc-500">{c.sent_at ? new Date(c.sent_at).toLocaleDateString() : "—"}</div>
                  </td>
                  <td className="px-3 py-2.5 text-right">{(s.recipients||0).toLocaleString()}</td>
                  <td className="px-3 py-2.5 text-right">{sent.toLocaleString()}</td>
                  <td className="px-3 py-2.5 text-right">{(s.unique_opens||0).toLocaleString()}</td>
                  <td className="px-3 py-2.5 text-right">{(s.unique_clicks||0).toLocaleString()}</td>
                  <td className="px-3 py-2.5 text-right">{sent ? ((s.unique_opens/sent)*100).toFixed(1) : 0}%</td>
                  <td className="px-3 py-2.5 text-right">{sent ? ((s.unique_clicks/sent)*100).toFixed(1) : 0}%</td>
                  <td className="px-3 py-2.5 text-right">{(s.bounced||0).toLocaleString()}</td>
                  <td className="px-3 py-2.5 text-right">{(s.unsubscribed||0).toLocaleString()}</td>
                </tr>
              );
            })}
            {sentItems.length === 0 && <tr><td colSpan={10} className="p-8 text-center text-sm text-zinc-500">No sent campaigns yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
